'use strict';

var React = require('react');

var SvgFulfillmentOnHoldMajor = function SvgFulfillmentOnHoldMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8v2.75a.75.75 0 0 0 1.5 0v-2.894a2.75 2.75 0 0 0-.462-1.526l-1.219-1.828a2.25 2.25 0 0 0-1.872-1.002h-5.796a2.25 2.25 0 0 0-1.836.95l-1.31 1.847a2.75 2.75 0 0 0-.505 1.59v6.863c0 .966.784 1.75 1.75 1.75h6a.75.75 0 0 0 0-1.5h-6a.25.25 0 0 1-.25-.25v-6.75h10Zm-7.85-3a.75.75 0 0 0-.611.316l-.839 1.184h3.55v-1.5h-2.1Zm3.6 1.5h3.599l-.778-1.166a.75.75 0 0 0-.624-.334h-2.197v1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-4Zm.5 3.5v-2h3v2h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 12.5a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.25a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0v-4Z"
  }));
};
SvgFulfillmentOnHoldMajor.displayName = "FulfillmentOnHoldMajor";

exports.SvgFulfillmentOnHoldMajor = SvgFulfillmentOnHoldMajor;
